import styled, { css } from 'styled-components';
import { DatePicker as AntdDatePicker } from 'antd';

import { lighten } from 'utils/colours';
export const pickerStylesOverride = css`
    &.ant-picker:hover,
    &.ant-picker-focused {
        border-color: ${({ theme }) => lighten(theme.colour.primary)};
        box-shadow: ${({ theme }) => `0 0 0 2px ${lighten(theme.colour.primary, 40)}`};
    }
`;

const DatePicker = styled(AntdDatePicker)`
    ${pickerStylesOverride};
`;

export default DatePicker;
